export const flashConstants = {
  SHOW: 'SHOW_FLASH',
  HIDE: 'HIDE_FLASH',
  TYPES: {
    SUCCESS: 'success',
    ERROR: 'error',
    DANGER: 'danger',
    INFO: 'info',
    WARNING: 'warning',
  },
  LENGTH: 4000,
  DEFAULT_ERROR_MESSAGE: 'Something went wrong, Please reach out to the administrator',
};
